<template>
    <div class="modal-content !rounded-[20px]">
        <div class="modal-body flex flex-col gap-4 !px-[30px] py-4">
            <div class="flex items-center justify-between">
                <div v-if="isPartnerQuote && Object.keys(quoteDetail).length > 0" class="flex items-center gap-2">
                    <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                    <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                    <h2 v-if="!isShowApproved"
                        class="m-0 font-lato font-bold text-[20px] text-[#092E87]">Pricebook
                    </h2>
                    <h2 v-else class="m-0 font-lato font-bold text-[20px] text-[#092E87]">Approved Parts List</h2>
                </div>
                <div v-else class="flex items-center gap-2">
                    <h2 class="m-0 font-lato font-bold text-[20px] text-[#092E87]">Pricebook</h2>
                </div>
                <button @click="closeClicked" type="button" data-bs-dismiss="modal" aria-label="Close"
                    class="w-[40px] h-[40px] p-2 bg-[#fff]">
                    <img src="@/assets/images/modal-cross-icon.png" class="w-full h-full">
                </button>
            </div>
            <div class="relative pr-2">
                <input type="text" v-model="search" placeholder="Enter part name to search..."
                    class="form-control !pl-[50px] !h-[45px] border-0 !rounded-full overflow-hidden shadow-[0_0_20px_0_rgba(0,0,0,0.15)] focus:!shadow-[0_0_20px_0_rgba(0,0,0,0.15)]">
                <div class="absolute top-0 left-0 h-full flex items-center px-[15px]">
                    <img src="@/assets/images/search-grey-icon.png" class="w-[20px] h-[20px]">
                </div>
            </div>
            <div class="responsiveOreitationConsumerHeightAdjust flex flex-col gap-1 max-h-[230px] overflow-x-hidden overflow-y-auto pr-2 
                [&::-webkit-scrollbar]:w-[5px]
                [&::-webkit-scrollbar-track]:bg-[#EFEFEF]
                [&::-webkit-scrollbar-track]:rounded-xl
                [&::-webkit-scrollbar-thumb]:bg-[#ff5b00]
                [&::-webkit-scrollbar-thumb]:rounded-xl
                [&::-webkit-scrollbar-button]:hidden">
                <div v-for="(item, index) in filteredList" :key="index"
                    class="px-3 py-[7px] rounded-[10px] border border-[#EFEFEF]">
                    <label class="relative flex items-center justify-between gap-2 w-full cursor-pointer ">
                        <input v-model="selectedItems" type="checkbox" class="peer hidden" :value="{
                            title: item.part_name,
                            part_price: item.cost_with_markup ?? 0,
                            service_part_id: item.part_id,
                            service: item.service,
                            is_max_markup_applicable: item.is_max_markup_applicable ?? 0,
                            max_allowed_price: item.max_allowed_price
                        }" />
                        <span class="text-[14px] text-[#666666] peer-checked:text-[#092E87]">{{ item.part_name }}</span>
                        <span class="peer-checked:hidden">
                            <img src="../../assets/images/double-check-grey.png" alt="Unchecked Icon"
                                class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] object-contain" />
                        </span>
                        <span class="hidden peer-checked:!block">
                            <img src="../../assets/images/double-check-blue.png" alt="Checked Icon"
                                class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] object-contain" />
                        </span>
                    </label>
                </div>
                <div v-if="((filteredList??[]).length == 0)" class="text-[16px] text-center text-[#999]">
                    No Record Found
                </div>

            </div>
            <div class="flex justify-center">
                <button @click="doneBtnClicked"
                    class="px-4 py-1.5 border-1 rounded-full text-[16px] font-lato transition duration-300 border-[#FE5000] mobile:text-white laptop:text-[#FE5000] mobile:bg-[#FE5000] laptop:bg-white laptop:hover:bg-[#FE5000] laptop:hover:text-[#fff]">
                    Done
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import {
    mapActions,
    mapGetters
} from "vuex";
import { enableScroll } from "../../helpers/scrollHelper";



export default {
    components: {
    },
    props: ["list", "openModal"],

    data() {
        return {
            modal: null,
            search: '',
            selectedItems: [],
            partListArray: []
        }
    },
    computed: {
        ...mapGetters(["apiCallCallback", "partList", "partCategories", "quoteDetail"]),

        filteredList() {
            return this.partListArray.filter((item) => {
                return Object.keys(item)
                    .some(key => ('' + item[key]).toLowerCase().includes(this.search.toLowerCase()))
            })
        },

        isPartnerQuote() {
            return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
        },

        isShowApproved() {
            return this.quoteDetail?.partner_info?.show_approved_item_text == 1 || false
        },

    },

    watch: {


        partList: function () {

        },

        openModal: function () {
            this.partListArray = [];
            let itemsids = [];
            this.list.forEach(item => {
                itemsids.push(item.service_part_id);
            });
            this.partListArray = this.partList.filter((e) => !itemsids.includes(e.part_id));
        },

    },

    mounted() {
        if (this.isPartnerQuote) {
            this.getPartCategoriesData()
            this.getPartList({
                url: "/partner/parts/list",
                params: {
                    uq_id: this.quoteDetail.id
                }
            });
        } else {
            this.getPartList({
                url: "/universal_quote/parts/list",
                params: {
                    manual_quote_id: this.quoteDetail.id
                }
            });
        }
    },

    methods: {

        ...mapActions(["getPartList", "getPartCategories"]),


        getPartCategoriesData() {
            this.getPartCategories({
                trade_id: this.quoteDetail.trade_id,
                uq_id: this.quoteDetail.id
            });
        },

        doneBtnClicked() {
            this.$emit("event", this.selectedItems)
            this.closeClicked()
        },

        closeClicked() {
            enableScroll()
            document.documentElement.style.overflow = '';
            this.search = '',
                this.selectedItems = []
        },
    }

}
</script>
